export const workFlowConstants = {
  CONTINUE_WORKFLOW_REQUEST: "CONTINUE_WORKFLOW_REQUEST",
  CONTINUE_WORKFLOW_SUCCESS: "CONTINUE_WORKFLOW_SUCCESS",
  CONTINUE_WORKFLOW_FAILURE: "CONTINUE_WORKFLOW_FAILURE",
  CANCEL_WORKFLOW_REQUEST: "CANCEL_WORKFLOW_REQUEST",
  CANCEL_WORKFLOW_SUCCESS: "CANCEL_WORKFLOW_SUCCESS",
  CANCEL_WORKFLOW_FAILURE: "CANCEL_WORKFLOW_FAILURE",
};